import { Theme, makeStyles } from '@material-ui/core';

export const useInputStyles = makeStyles((theme: Theme) => ({
  root: {
    background: '#FFFFFF',
    fontFamily: 'Inter',
    borderRadius: 8,
    // '&:hover': {
    //   border: '0.1px solid #FA6400'
    // },
    color: '#666666',
    '&$error': {
      backgroundColor: '#fff',
      borderLeftColor: '#C51111',
      color: '#C51111',
      fontWeight: 500,
    },
  },
  error: {},
}));
